// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error-view-m__wrapper__5WVub","message":"error-view-m__message__2ATLA","close-wrapper":"error-view-m__close-wrapper__2Cl4s"};